import { Text, Box, Flex, Button, Icon, Tooltip } from '@chakra-ui/react';
import MDropZoneMulti from 'components/molecules/MDropZoneMulti';
import { useGetCompanyInfoSelector } from 'core/redux/selectors/authSelectors';
import { useTranslation } from 'helpers/languages/translations';
import { aggregateDisclamerCompanies } from 'pages/ImageManagement/contants';
import icons from 'shared/icons';
import useUploadSection from './ImageUploadContainer';

const accept = { 'image/*': [] };

const UploadSection = ({
    image_caractersitics,
    image_type,
    filesToUpload,
    isLoading,
    overwrite,
    retailers_id,
    handleFileChange,
    handleUpload,
}: ReturnType<typeof useUploadSection>) => {
    const UploadIcon = icons.upload;
    const translate = useTranslation();
    const companyInfo = useGetCompanyInfoSelector();

    return (
        <Flex w="40%" justifyContent="flex-start" direction="column" textAlign="start">
            <Text fontSize="md">{translate('pictures.upload.format')}</Text>
            <Flex alignItems="center">
                {image_caractersitics}
                <Tooltip label={translate('pictures.format.description')}>
                    <Icon as={icons.info} boxSize="20px" ml={3} />
                </Tooltip>
            </Flex>

            <Text fontSize="md">{translate('pictures.upload.type')}</Text>
            <Flex alignItems="center">
                {image_type}
                <Tooltip label={translate('pictures.type.description')}>
                    <Icon as={icons.info} boxSize="20px" ml={3} />
                </Tooltip>
            </Flex>

            <Text fontSize="md">{translate('pictures.upload.retailers')}</Text>
            <Flex alignItems="center">
                {retailers_id}
                <Tooltip label={translate('pictures.retailers.description')}>
                    <Icon as={icons.info} boxSize="20px" ml={3} />
                </Tooltip>
            </Flex>

            {aggregateDisclamerCompanies.includes(companyInfo?.id!) && (
                <Text fontStyle="italic">{translate('pictures.upload.aggregateRetailerDisclamer')}</Text>
            )}

            <Text fontSize="md">{translate('pictures.upload.overwrite')}</Text>
            <Flex alignItems="center">
                {overwrite}
                <Tooltip label={translate('pictures.overwrite.description')}>
                    <Icon as={icons.info} boxSize="20px" ml={3} />
                </Tooltip>
            </Flex>

            <Text fontSize="md" pt={4} mb={2}>
                {translate('pictures.upload.files')}
            </Text>
            <Box py={4}>
                <MDropZoneMulti
                    chosenFiles={filesToUpload}
                    handleChangeFile={handleFileChange}
                    maxFiles={500}
                    accept={accept}
                    icon={icons.image}
                />
            </Box>
            <Flex mt="24px" justifyContent="space-between">
                <Button
                    rightIcon={<Icon as={UploadIcon} />}
                    isLoading={isLoading}
                    onClick={handleUpload}
                    colorScheme="blue"
                    bg="blueMain"
                    isDisabled={!filesToUpload.length}
                >
                    {translate('keyword.upload.apply')}
                </Button>
            </Flex>
        </Flex>
    );
};

export default UploadSection;
